import React from 'react';
import { Page } from 'react-onsenui';
import * as sdkclaro from '@claropay/claro-pay-sdk-v2'
import PlansContainer from "../containers/PlansContainer"

const TelcelPlansPage = ({ match, location, history  }) => {
    const { 
        state: { 
            sdkVersion, 
            paymentsConfig, 
            isClaroPartner,
            serviceConfigIndex,
            tagServiceId,
            isContainerTelcel
        }
    } = location;
    sdkclaro.getInstance().switchGoBackButton(true)
    return (
        <Page id="telcel-plans-page">
            <PlansContainer
                serviceConfigIndex={serviceConfigIndex} 
                sdkVersion = {sdkVersion} 
                paymentsConfig = {paymentsConfig} 
                isClaroPartner = {isClaroPartner}
                tagServiceId={tagServiceId}
                history = {history}
                isContainerTelcel={isContainerTelcel}
            />
        </Page>    
  );
};


export default TelcelPlansPage